'use client';

import { STALE_DEPLOYMENT_RESTORED_MESSAGE } from '#/data/constants';
import { takePendingText, trackPendingText } from '#/lib/stale-deployment';
import { useEffect } from 'react';
import { toast } from 'react-toastify';

/**
 * 배포 스큐·청크 회복으로 페이지를 새로 불러온 뒤, 보존해 둔 입력을 되돌려
 * 놓습니다. (#271) 아울러 현재 입력을 계속 추적해 둔다 — 오류 바운더리는 에디터
 * 상태에 접근할 수 없어서, 청크 회복(#273)이 새로고침하기 전에 이 추적본을 저장한다.
 *
 * 복원은 마운트 이후(effect)에 넣는다 — 첫 렌더에서 sessionStorage 를 읽으면
 * 서버 렌더 결과와 달라져 hydration 이 깨진다.
 */
export function useRestorePendingText(
  setText: (text: string) => void,
  text: string
) {
  useEffect(() => {
    const pending = takePendingText();
    if (!pending) return;

    setText(pending);
    toast.info(STALE_DEPLOYMENT_RESTORED_MESSAGE);
    // setText 는 useState 의 setter 라 안정적이다. 입력 복원은 마운트 시 한 번뿐.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    trackPendingText(text);
  }, [text]);
}
